import { render, staticRenderFns } from "./PromotionPenple.vue?vue&type=template&id=a7b26734"
import script from "./PromotionPenple.vue?vue&type=script&lang=js"
export * from "./PromotionPenple.vue?vue&type=script&lang=js"
import style0 from "./PromotionPenple.vue?vue&type=style&index=0&id=a7b26734&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports